import { useTranslation } from 'react-i18next'
import { Form, useNavigation } from 'react-router'
import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'

type ImpersonationBannerProps = {
	targetName: string
}

export function ImpersonationBanner({ targetName }: ImpersonationBannerProps) {
	const { t } = useTranslation()
	const navigation = useNavigation()
	const isSubmitting =
		navigation.state === 'submitting' &&
		navigation.formAction === '/resources/stop-impersonation'

	return (
		<div className="bg-accent/80 border-border fixed inset-x-0 top-0 z-50 border-b backdrop-blur-sm">
			<div className="mx-auto flex min-h-12 max-w-7xl items-center justify-between gap-3 px-4 py-2 sm:px-6">
				<div className="text-sm font-medium">
					{t('common.impersonation.banner', {
						target: targetName,
						defaultValue: 'Impersonating {{target}}',
					})}
				</div>
				<Form method="post" action="/resources/stop-impersonation">
					<Button size="sm" variant="outline" disabled={isSubmitting}>
						<Icon name="arrow-left" size="sm" className="mr-2" />
						{t('common.impersonation.exit', {
							defaultValue: 'Exit impersonation',
						})}
					</Button>
				</Form>
			</div>
		</div>
	)
}
